import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { xs_isMobile } from "../../..";
import { getLabel } from "../../../data/labels";
import { classIf } from '../../utils/classIf';
import { getConfiguration } from '../../utils/configuration';
import { getStreamingId } from "../streamingUtils";

import './StreamingWidgetToggler.css';

export default function StreamingWidgetToggler(props) {
    const conf = getConfiguration();
    const mainContext = props.mainContext;
    const [streamingToggled,setStreamingToggled] = useState(false);
    const [streamingVisible,setStreamingVisible] = useState(false);
    const streamingId = getStreamingId(props.streaming);
    const ref = props.widgetContainerRef;

    function toggleStreaming() {
        setStreamingToggled(!streamingToggled);
        props.toggleStreaming('betradar-widget');
    }

    function resetStreaming() {
        setStreamingToggled(false);
        setStreamingVisible(false);

        /*if (props.resetStreaming) {
            props.resetStreaming();
        }*/
    }

    function showStreaming() {
        if (!streamingToggled) {
            toggleStreaming();
        }
    }

    function showWidget() {
        if (streamingToggled) {
            toggleStreaming();
        }
    }


    function toggleBetradarWidgetS5Elements(isVisible) {
        if (!isVisible) {
            ref.current.classList.add("d-none");
        } else {
            ref.current.classList.remove("d-none");
        }
    }


    useEffect(function() {
        toggleBetradarWidgetS5Elements(!streamingToggled);
    }, [streamingToggled])


    useEffect(function() {
        if (conf.lstwc && streamingId && mainContext?.streamingId == streamingId && (props.streamingContainer == 'betradar-widget' || xs_isMobile )) {
            setStreamingToggled(true);

            setTimeout(() => {
                setStreamingVisible(true);

            }, 100);
        }
        return () => {
            resetStreaming();
        }
    }, [props.widgetContainerId, props.matchId, mainContext?.streamingId]); 

    return(
        <>
            {conf.lstwc && streamingId &&
                <>
                    <div id="btn-container-streaming-widget-toggler">
                        <div id="btn-streaming-toggle" className={"btn-streaming-widget-toggler-widget__btn widget" + classIf(streamingToggled, 'btn-streaming-widget-toggler-widget__btn--active')} onClick={showStreaming} title={getLabel('live_page.stream_widget.play_stream')}></div>
                        <div id="btn-widget-toggle" className={"btn-streaming-widget-toggler-widget__btn widget" + classIf(!streamingToggled, 'btn-streaming-widget-toggler-widget__btn--active')} onClick={showWidget} title={getLabel('live_page.stream_widget.show_tracker')}></div>
                    </div>
                    <>{streamingVisible && props.streamingComponent}</>
                </>
            }
        </>
    );
}
